<template>
    <div class="container" style="margin-top: 2%;">
        <div class="row">
            <div class="col-md-3">
                <div class="generic_content clearfix">
                    <div class="generic_head_price d-flex justify-content-center align-items-center">
                        <h4>Lo más visto</h4>
                    </div>
                    <div class="row mt-3">
                        <div id="carouselLoMasVisto" class="carousel carousel-dark slide carousel-fade" data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div v-for="(item, index) in losmasvistosprods" class="carousel-item" :class="{ active: index === 0 }" :key="'slider-' + index" data-bs-interval="1500">
                                    <router-link :to="{ name: 'verprods', params: { id: item.k_parte } }" class="text-decoration-none">
                                        <div class="card shadow-sm border-0 hover-shadow" style="max-width: 14rem; margin: auto; min-height: 420px;">
                                            <img v-if="item.PicturesUrl && Object.values(item.PicturesUrl).length > 0"
                                                :src="item.PicturesUrl[item.categorias[0].marcas.viewimagesprinc ? item.categorias[0].marcas.viewimagesprinc : 4].sm"
                                                :alt="item.k_parte" class="card-img-top img-fluid fixed-img" />
                                            <img v-else :src="getImagePath('img/display/Placeholder.webp')"
                                                :alt="item.k_parte" class="card-img-top img-fluid fixed-img" />

                                            <div class="card-body text-center d-flex flex-column"
                                                style="height: 200px;">
                                                <!-- Badges -->
                                                <div class="mb-2" style="min-height: 40px;">
                                                    <BadgesProducto :item="item" wrapperClass="d-flex flex-wrap gap-2"
                                                        :fontSize="'13px'" />
                                                </div>

                                                <!-- Título -->
                                                <div class="mb-1" style="min-height: 28px;">
                                                    <h4 class="card-title-kparte">{{ item.k_parte }}</h4>
                                                </div>

                                                <!-- Línea -->
                                                <div class="mb-1" style="min-height: 40px;">
                                                    <p class="card-text-linea" v-if="item.linea">{{ item.linea }}</p>
                                                </div>
                                                <!-- Descripción -->
                                                <div class="mb-1" style="min-height: 60px;">
                                                    <span v-if="item.aplicaciones && item.aplicaciones.length > 0"
                                                        class="card-text-sugerencia">
                                                        {{ item.aplicaciones[0].marca }} - {{
                                                            item.aplicaciones[0].modelo }} ({{ item.aplicaciones[0].year
                                                        }})
                                                        <span
                                                            v-if="item.aplicaciones[0].posicion && item.aplicaciones[0].posicion !== '-'">
                                                            <strong>{{ item.aplicaciones[0].posicion }}</strong> -
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="generic_content clearfix">
                    <div class="generic_head_price d-flex justify-content-center align-items-center">
                        <h4>Lo más buscado</h4>
                    </div>
                    <div class="row mt-3">
                        <div id="carouselLoMasbuscados" class="carousel carousel-dark slide carousel-fade"
                            data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div v-for="(item, index) in masbuscados" class="carousel-item" :class="{ active: index === 0 }" :key="'slidermasbuscados-' + index" data-bs-interval="1500">
                                    <router-link :to="{ name: 'verprods', params: { id: item.k_parte } }" class="text-decoration-none">
                                        <div class="card shadow-sm border-0 hover-shadow" style="max-width: 14rem; margin: auto; min-height: 420px;">
                                            <img v-if="item.PicturesUrl && Object.values(item.PicturesUrl).length > 0"
                                                :src="item.PicturesUrl[item.categorias[0].marcas.viewimagesprinc ? item.categorias[0].marcas.viewimagesprinc : 4].sm"
                                                :alt="item.k_parte" class="card-img-top img-fluid fixed-img" />
                                            <img v-else :src="getImagePath('img/display/Placeholder.webp')"
                                                :alt="item.k_parte" class="card-img-top img-fluid fixed-img" />

                                            <div class="card-body text-center d-flex flex-column"
                                                style="height: 200px;">
                                                <!-- Badges -->
                                                <div class="mb-2" style="min-height: 40px;">
                                                    <BadgesProducto :item="item" wrapperClass="d-flex flex-wrap gap-2"
                                                        :fontSize="'13px'" />
                                                </div>

                                                <!-- Título -->
                                                <div class="mb-1" style="min-height: 28px;">
                                                    <h4 class="card-title-kparte">{{ item.k_parte }}</h4>
                                                </div>

                                                <!-- Línea -->
                                                <div class="mb-1" style="min-height: 40px;">
                                                    <p class="card-text-linea" v-if="item.linea">{{ item.linea }}</p>
                                                </div>
                                                <!-- Descripción -->
                                                <div class="mb-1" style="min-height: 60px;">
                                                    <span v-if="item.aplicaciones && item.aplicaciones.length > 0"
                                                        class="card-text-sugerencia">
                                                        {{ item.aplicaciones[0].marca }} - {{
                                                            item.aplicaciones[0].modelo }} ({{ item.aplicaciones[0].year
                                                        }})
                                                        <span
                                                            v-if="item.aplicaciones[0].posicion && item.aplicaciones[0].posicion !== '-'">
                                                            <strong>{{ item.aplicaciones[0].posicion }}</strong> -
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="generic_content clearfix">
                    <div class="generic_head_price d-flex justify-content-center align-items-center">
                        <h4>Últimos Vendidos</h4>
                    </div>
                    <div class="row mt-3">
                        <div id="carouselprodsultmasvend" class="carousel carousel-dark slide carousel-fade" data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div v-for="(item, index) in prodsultmasvend" class="carousel-item" :class="{ active: index === 0 }" :key="'sliderprodsultmasvend-' + index" data-bs-interval="1500">
                                    <router-link :to="{ name: 'verprods', params: { id: item.k_parte } }" class="text-decoration-none">
                                        <div class="card shadow-sm border-0 hover-shadow" style="max-width: 14rem; margin: auto; min-height: 420px;">
                                            <img v-if="item.PicturesUrl && Object.values(item.PicturesUrl).length > 0"
                                                :src="item.PicturesUrl[item.categorias[0].marcas.viewimagesprinc ? item.categorias[0].marcas.viewimagesprinc : 4].sm"
                                                :alt="item.k_parte" class="card-img-top img-fluid fixed-img" />
                                            <img v-else :src="getImagePath('img/display/Placeholder.webp')"
                                                :alt="item.k_parte" class="card-img-top img-fluid fixed-img" />

                                            <div class="card-body text-center d-flex flex-column"
                                                style="height: 200px;">
                                                <!-- Badges -->
                                                <div class="mb-2" style="min-height: 40px;">
                                                    <BadgesProducto :item="item" wrapperClass="d-flex flex-wrap gap-2"
                                                        :fontSize="'13px'" />
                                                </div>
                                                <!-- Título -->
                                                <div class="mb-1" style="min-height: 28px;">
                                                    <h4 class="card-title-kparte">{{ item.k_parte }}</h4>
                                                </div>

                                                <!-- Línea -->
                                                <div class="mb-1" style="min-height: 40px;">
                                                    <p class="card-text-linea" v-if="item.linea">{{ item.linea }}</p>
                                                </div>
                                                <!-- Descripción -->
                                                <div class="mb-1" style="min-height: 60px;">
                                                    <span v-if="item.aplicaciones && item.aplicaciones.length > 0"
                                                        class="card-text-sugerencia">
                                                        {{ item.aplicaciones[0].marca }} - {{
                                                            item.aplicaciones[0].modelo }} ({{ item.aplicaciones[0].year
                                                        }})
                                                        <span
                                                            v-if="item.aplicaciones[0].posicion && item.aplicaciones[0].posicion !== '-'">
                                                            <strong>{{ item.aplicaciones[0].posicion }}</strong> -
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="generic_content clearfix">
                    <div class="generic_head_price d-flex justify-content-center align-items-center">
                        <h4>Más Vendido Hoy</h4>
                    </div>
                    <div class="row mt-3">
                        <div id="carouselprodsultmasvend" class="carousel carousel-dark slide carousel-fade"
                            data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div v-for="(item, index) in prodsultmasvendhoy" class="carousel-item" :class="{ active: index === 0 }" :key="'sliderprodsultmasvend-' + index" data-bs-interval="1500">
                                    <router-link :to="{ name: 'verprods', params: { id: item.k_parte } }" class="text-decoration-none">
                                        <div class="card shadow-sm border-0 hover-shadow" style="max-width: 14rem; margin: auto; min-height: 420px;">
                                            <img v-if="item.PicturesUrl && Object.values(item.PicturesUrl).length > 0"
                                                :src="item.PicturesUrl[item.categorias[0].marcas.viewimagesprinc ? item.categorias[0].marcas.viewimagesprinc : 4].sm"
                                                :alt="item.k_parte" class="card-img-top img-fluid fixed-img" />
                                            <img v-else :src="getImagePath('img/display/Placeholder.webp')"
                                                :alt="item.k_parte" class="card-img-top img-fluid fixed-img" />

                                            <div class="card-body text-center d-flex flex-column"
                                                style="height: 200px;">
                                                <!-- Badges -->
                                                <div class="mb-2" style="min-height: 40px;">
                                                    <BadgesProducto :item="item" wrapperClass="d-flex flex-wrap gap-2"
                                                        :fontSize="'13px'" />
                                                </div>
                                                <!-- Título -->
                                                <div class="mb-1" style="min-height: 28px;">
                                                    <h4 class="card-title-kparte">{{ item.k_parte }}</h4>
                                                </div>
                                                <!-- Línea -->
                                                <div class="mb-1" style="min-height: 20px;">
                                                    <p class="card-text-linea" v-if="item.linea">{{ item.linea }}</p>
                                                </div>
                                                <!-- Descripción -->
                                                <div class="mb-1" style="min-height: 40px;">
                                                    <span v-if="item.aplicaciones && item.aplicaciones.length > 0"
                                                        class="card-text-sugerencia">
                                                        {{ item.aplicaciones[0].marca }} - {{
                                                            item.aplicaciones[0].modelo }} ({{ item.aplicaciones[0].year
                                                        }})
                                                        <span
                                                            v-if="item.aplicaciones[0].posicion && item.aplicaciones[0].posicion !== '-'">
                                                            <strong>{{ item.aplicaciones[0].posicion }}</strong> -
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { defineAsyncComponent } from 'vue'
export default {
    name: 'TemplateWithColumns',
    components: {
        BadgesProducto: defineAsyncComponent(() => import('../Sliders/Badges.vue')),
    },
    data() {
        return {
            losmasvistosprods: [],
            masbuscados: [],
            prodsultmasvend: [],
            prodsultmasvendhoy: [],
            observer: null, // Para el lazy loading
            productCardRef: null, // Referencia para el producto
        };
    },
    methods: {
        getInterval(index) {
            // Puedes ajustar la lógica para decidir el intervalo según el índice
            if (index === 0) {
                return 3000; // Primer slide con intervalo más largo
            } else if (index === this.losmasvistosprods.length - 1) {
                return 5000; // Último slide con intervalo más largo
            } else {
                return 2000; // Intervalo más corto para los demás
            }
        },
        getImagePath(relativePath) {
            return `${window.location.origin}/${relativePath}`;
        },

        async fetchData() {
            try {
                const response = await axios.get('/homedestacados/vistas');
                this.losmasvistosprods = Object.values(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        async fetchDataMasbuscados() {
            try {
                const response = await axios.get('/homedestacados/masbuscados');
                this.masbuscados = Object.values(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        async fetchDataProdsultmasvends() {
            try {
                const response = await axios.get('/homedestacados/prodsultmasvend');
                this.prodsultmasvend = Object.values(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        async fetchDataProdsultmasvendhoy() {
            try {
                const response = await axios.get('/homedestacados/prodsultmasvendhoy');
                this.prodsultmasvendhoy = Object.values(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        },
        observeSection() {
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.fetchData();
                        this.observer.disconnect();
                    }
                });
            });
            this.observer.observe(this.$refs.lazyLoadSection);
        },
        flipCard() {
            this.productCardRef.classList.add('flip180');
        },
        flipCardBack() {
            this.productCardRef.classList.remove('flip180');
        }
    },
    mounted() {
        this.fetchData()
        this.fetchDataMasbuscados()
        this.fetchDataProdsultmasvends()
        this.fetchDataProdsultmasvendhoy()
    },
    computed: {
        proBusOClient() {
            return this.$store.getters.proBusOClient;
        }
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
        this.losmasvistosprods = [];
        this.masbuscados = [];
        this.prodsultmasvend = [];
        this.prodsultmasvendhoy = [];
    }
};
</script>
<style scoped>
.fixed-img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    padding: 10px;
}

</style>